import type { Shortcut } from './shortcut.js'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const shortcutActions = [
  'Search',
  'ShowHelp',
  'Suggestions',
  'Save',
  'SoftBreak',
  'ExitBreak',
  'Comments',
  'Link',
  'TogglePool',
  'RunCommand',
  'InsertPage',
] as const
type ShortCutType = (typeof shortcutActions)[number]

/**
 * Canonical keyboard shortcut inventory.
 *
 * This is the single source of truth for app-level shortcuts. Plugin and
 * feature authors who add a new shortcut MUST register it here so that:
 *
 *   1. The help dialog (Phase 2 design system deliverable — TBD) can render
 *      a complete list grouped by context.
 *   2. Reviewers can spot collisions before merge.
 *   3. The accessibility baseline (Design System v1 Epic, Notion) holds —
 *      every action has a documented keyboard equivalent.
 *
 * The `context` field declares scope: 'global' for shortcuts active anywhere,
 * 'editor' for editor-only, 'audio' for transport/recording UIs, 'music' for
 * music-domain affordances (e.g., transposition).
 */
export const shortcuts: Record<ShortCutType, Shortcut> = {
  RunCommand: {
    description: 'Run Command',
    hotkey: 'mod+k',
    context: 'global',
  },
  InsertPage: {
    description: 'Insert New Page',
    hotkey: 'mod+n',
    context: 'global',
  },

  Comments: {
    description: 'Comments',
    hotkey: 'shift+mod+m',
    context: 'editor',
  },
  Search: {
    description: 'Search',
    hotkey: 'shift+mod+f',
    context: 'global',
  },
  SoftBreak: {
    description: 'Soft Break',
    hotkey: 'shift+enter',
    context: 'editor',
  },

  ExitBreak: {
    description: 'Exit Block',
    hotkey: 'mod+enter',
    context: 'editor',
  },
  ShowHelp: {
    description: 'Show Help',
    hotkey: 'mod+?',
    context: 'global',
  },

  Suggestions: {
    description: 'Suggestions',
    hotkey: 'ctrl+space',
    context: 'editor',
  },

  Save: {
    description: 'Save',
    hotkey: 'mod+s',
    context: 'global',
  },
  Link: {
    description: 'Link',
    hotkey: 'mod+k',
    context: 'editor',
  },
  TogglePool: {
    description: 'Show/Hide Pool',
    hotkey: 'mod+p',
    context: 'global',
  },
}

export default shortcuts
